export default "__VITE_ASSET__DPEmeWO9__"